import { multipartFetchExchange } from '@urql/exchange-multipart-fetch'
import { cacheExchange, createClient, dedupExchange } from 'urql'

export const client = createClient({
  url: `${process.env.NEXT_PUBLIC_API_BASE_URL}/graphql`,
  exchanges: [dedupExchange, cacheExchange, multipartFetchExchange],
  fetchOptions: () => {
    return {
      credentials: 'include',
      headers: {
        // Authorization: `Bearer ${AppStore.userToken}`,
      },
    }
  },
})
